module.exports = "/img/_/_/_/assets/images/creeper/battle/common//44.jpg?84e5d640e046f1a58764d5ec70a7554c";